import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { DataFormat } from "imports/Utils";
import { GeneralStaffelItemFragment } from "__generated__/view/staffels/graphql/staffel.fragments.generated";

const GasolineStaffelItemsTable = ({
	content,
	contentLoading,
}: {
	content: GeneralStaffelItemFragment[];
	contentLoading?: boolean;
}) => (
	<Table
		id="gasolineStaffelTable"
		content={content}
		contentLoading={contentLoading}
		columns={[ {
			id: "startPrice",
			title: intl.formatMessage({ id: "GASOLINE_STAFFEL_START_PRICE" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.price("startPrice" in row ? row.startPrice : undefined),
		}, {
			id: "endPrice",
			title: intl.formatMessage({ id: "GASOLINE_STAFFEL_END_PRICE" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.price("endPrice" in row ? row.endPrice : undefined),
		}, {
			id: "surcharge",
			title: intl.formatMessage({ id: "GASOLINE_STAFFEL_SURCHARGE" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.percentage("surcharge" in row ? row.surcharge : undefined),
		} ]}
		disableFooter />
);

export default GasolineStaffelItemsTable;
